import { render, staticRenderFns } from "./ScoreRing.vue?vue&type=template&id=4a822214&scoped=true&"
import script from "./ScoreRing.vue?vue&type=script&lang=js&"
export * from "./ScoreRing.vue?vue&type=script&lang=js&"
import style0 from "./ScoreRing.vue?vue&type=style&index=0&id=4a822214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a822214",
  null
  
)

export default component.exports